import React, { useState } from 'react';
import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';
import { Stack, Link, TextField, FormHelperText } from '@mui/material';

import { PurpleSwitch } from '../../Styles';
import { OpenSwal, notistackSnakebar, validateMobileNumber } from '../../Utils';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { FormControlLabel } from '@mui/material';



import CallOutlinedIcon from '@mui/icons-material/CallOutlined';

import { useSnackbar } from 'notistack';



import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { url_support_form } from '../../RoutesMap';
import { apiWithAuth } from '../../Services/Axios/axios';



export default function AppSupport() {
  const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
  const appThemeSecondaryColor = process.env.REACT_APP_THEME_SECONDARY_COLOR;
  const navigate = useNavigate();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [SupportCheckboxStatus, SupportCheckboxStatusSet] = useState(true);
  const [SubmitButtonLoadingStatus, SubmitButtonLoadingStatusSet] = useState(false);
  const [RadioSelectValue, setRadioSelectValue] = useState(null);
  const [ErrorMessageValues, setErrorMessageValues] = useState({});
  let support_tel_number = process.env.REACT_APP_ASSIGN_ACCEPT_SUPPORT_CALL_NUMBER;



  let radioButtonList = [
    { value: 'A specific assignment', label: 'A specific assignment' },
    { value: 'Change Availability', label: 'Change Availability' },
    { value: 'Time Finishing Assignments', label: 'Time Finishing Assignments' },
    { value: 'Discrepancy in rates or travel', label: 'Discrepancy in rates or travel' },
    { value: 'The iTi Live mobile app', label: 'The iTi Live mobile app' }
  ]


  const SubmitSupport = () => {
    let error_messages = {};
    setErrorMessageValues({});
    let return_val = true;
    let feedback_email_address = "";
    let feedback_mobile_number = "";



    if (RadioSelectValue === null) {
      error_messages = { ...error_messages, radio_error: "Please pick one option" };
      return_val = false;
    }


    if (SupportCheckboxStatus === false) {

      feedback_email_address = document.getElementById('feedback_email_address').value;
      feedback_mobile_number = document.getElementById('feedback_mobile_number').value;
      if (feedback_email_address === "") {
        error_messages = { ...error_messages, email_address: "Please enter email address" };
        return_val = false;
      }
      if (feedback_mobile_number === "") {
        error_messages = { ...error_messages, mobile_number: "Please enter mobile number" };
        return_val = false;
      }



    }
    let feedback_remarks = document.getElementById('feedback_value_remarks').value;

    if (feedback_remarks === "") {
      error_messages = { ...error_messages, feedback_remarks: "Please enter your feedback" };
      return_val = false;
    }

    if (return_val) {
      SubmitButtonLoadingStatusSet(true);

      let payload = {
        feedback_option: RadioSelectValue,
        feedback_remarks,
        feedback_email_address, feedback_mobile_number

      };
      apiWithAuth.post(url_support_form, payload, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
        if (response.data.status) {
          notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: response.data.message, variant: 'success' });
          navigate('/Interpreter/Dashboard');
        } else if (response.data.status === false && response.data.message === "Token Expired") {
          SubmitButtonLoadingStatusSet(false);
          OpenSwal('Token_error', navigate);
        } else {
          SubmitButtonLoadingStatusSet(false);
          OpenSwal('Axios_error', response.data.message);
        }
      }).catch(response => {
        SubmitButtonLoadingStatusSet(false);
        OpenSwal('Axios_error', response.message);
      });




    } else {
      setErrorMessageValues(error_messages);
    }
  }

  return (

    <Box  >

      <Box sx={{ mt: 2, mb: 6 }}>

        <Box>
          <Typography sx={{ typography: { xs: 'subtitle2', sm: 'body1', md: 'h6' } }} color={appThemeColor} style={{ fontWeight: 'bold', textDecoration: 'underline', textDecorationThickness: '2px', textUnderlineOffset: '5px' }} >Support</Typography>
        </Box>

        <Box mt={2}>
          <Typography color='#FF4C3B'>
            For any urgent matter affecting the timely completion of an assignment, please call us at <Button sx={{ color: 'unset', fontWeight: 'normal', padding: 0, margin: 0 }} LinkComponent={Link} href={`tel:${support_tel_number}`} endIcon={<CallOutlinedIcon style={{ fontSize: 14, marginLeft: '-2px' }} />} >{support_tel_number}</Button>
          </Typography>
        </Box>
        <Box mt={2}>
          <Typography color={appThemeColor}>
            For routine requests that are not time sensitive, We welcome your feedback.
          </Typography>
        </Box>
        <Box mt={2}>
          <Typography color={appThemeColor}>
            Can we contact you with information in your profile?
          </Typography>
        </Box>
        <Box mt={1} justifyContent='right' display='flex'>
          <Stack direction='row' alignItems='center'>
            <Typography color={appThemeColor}>No</Typography>
            <PurpleSwitch checked={SupportCheckboxStatus} onChange={(evt) => SupportCheckboxStatusSet(evt.target.checked)} />
            <Typography color={appThemeColor}>Yes</Typography>
          </Stack>

        </Box>

        <Box mt={2}>

          <FormControl>
            <FormLabel ><Typography color={appThemeColor}> I would like to share feedback or concern about: </Typography></FormLabel>
            <RadioGroup
              value={RadioSelectValue}
              onChange={(evt) => setRadioSelectValue(evt.target.value)}
            >



              {radioButtonList.map((datas, index) => {

                return (<FormControlLabel value={datas.value} key={index} control={<Radio color={appThemeSecondaryColor} />} label={<Typography color={appThemeColor}>{datas.label}</Typography>} />)

              })}


            </RadioGroup>
            {ErrorMessageValues.radio_error && <FormHelperText error={true}>{ErrorMessageValues.radio_error}</FormHelperText>}
          </FormControl>
        </Box>



        {SupportCheckboxStatus === false && <Box mt={2}>


          <TextField fullWidth
            id="feedback_email_address" label="Email Address" required
            color={appThemeSecondaryColor} helperText={ErrorMessageValues.email_address && ErrorMessageValues.email_address} error={ErrorMessageValues.email_address ? true : false}
          />

          <TextField fullWidth sx={{ mt: 2 }}
            id="feedback_mobile_number" label="Mobile Number" required onKeyDownCapture={(evt) => validateMobileNumber(evt)}
            color={appThemeSecondaryColor} helperText={ErrorMessageValues.mobile_number && ErrorMessageValues.mobile_number} error={ErrorMessageValues.mobile_number ? true : false}
          />



        </Box>}


        <Box mt={3}>


          <TextField fullWidth
            id="feedback_value_remarks" label="Feedback" multiline rows={3} required
            color={appThemeSecondaryColor} helperText={ErrorMessageValues.feedback_remarks && ErrorMessageValues.feedback_remarks} error={ErrorMessageValues.feedback_remarks ? true : false}
          />

        </Box>
        <Box mt={2} mb={2} display='flex' justifyContent='center'>


          <LoadingButton variant='contained' color={appThemeSecondaryColor} loadingPosition='end' loading={SubmitButtonLoadingStatus} sx={{ backgroundColor: appThemeColor, width: 250 }} endIcon={<CheckCircleOutlineIcon />} onClick={SubmitSupport} > Submit</LoadingButton>


        </Box>






      </Box>
    </Box >
  )
}

